import { render, staticRenderFns } from "./PageEditMicroCredentialReview.vue?vue&type=template&id=b1685e1c&"
import script from "./PageEditMicroCredentialReview.vue?vue&type=script&lang=js&"
export * from "./PageEditMicroCredentialReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports